import { render, staticRenderFns } from "./workflow-story-step.vue?vue&type=template&id=2765639e&scoped=true&"
import script from "./workflow-story-step.vue?vue&type=script&lang=js&"
export * from "./workflow-story-step.vue?vue&type=script&lang=js&"
import style0 from "./workflow-story-step.vue?vue&type=style&index=0&id=2765639e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2765639e",
  null
  
)

export default component.exports